import { Component, NgZone, TemplateRef, ViewChild, OnInit } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import { ApiService } from '../../shared/services/api.service';
import { DateService } from '../../shared/services/date.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ImageService } from '../../shared/services/image.service';
import { AuthService } from '../../shared/services/auth.service';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrl: './customers.component.scss'
})
export class CustomersComponent {

  gridApi: any;
  apiUrl: any;
  selectedCustomer: any;
  modalRef: any;
  customerData: any;
  // customerModal: any;
  @ViewChild('content') content!: TemplateRef<any>;
  @ViewChild('freezeModal') freezeModal!: TemplateRef<any>;

  // Properties for account freeze modal
  freezeModalData: any = null;
  freezeReason: string = '';
  otherReason: string = '';
  freezeNote: string = '';
  freezeModalRef: any = null;

  constructor(private _api: ApiService,
    private _dateService: DateService,
    private modalService: NgbModal,
    private zone: NgZone,
    private _date: DateService,
    private _imageService: ImageService,
    public _auth: AuthService,
    private router: Router
  ) {

  }

  columnDefs: ColDef[] = [
     {
      headerName: 'Action',
      field: 'action',
      width: 80,
      cellRenderer: (params: any) => {
        const button = document.createElement('button');
        button.classList.add('btn', 'btn-sm', 'btn-primary', 'active', 'rounded-pill');
        button.innerHTML = '<i class="bi bi-eye-fill"></i>';
        button.addEventListener('click', () => {
          this.zone.run(() => {
            this.onView(params);
          });
        });
        return button;
      }
    },
    {
      headerName: 'Account Status',
      field: 'isFrozen',
      editable: false,
      filter: true,
      filterParams: {
        filterOptions: ['contains'],
        maxNumConditions: 1
      },
      valueFormatter: (params) => {
        const data = params.data;
        if (data?.deletedByCustomer) {
          return 'DELETED';
        }
        return data?.isFrozen ? 'FROZEN' : 'ACTIVE';
      },
      cellClass: (params) => {
        const data = params.data;
        if (data?.deletedByCustomer) {
          return 'text-warning';
        }
        return data?.isFrozen ? 'text-danger' : 'text-success';
      },
      cellRenderer: (params: any) => {
        const data = params.data;
        let statusText = '';
        let reasonText = '';

        if (data?.deletedByCustomer) {
          statusText = 'DELETED';
          reasonText = data.freezeReason || 'Deleted by customer';
        } else if (data?.isFrozen) {
          statusText = 'FROZEN';
          reasonText = data.freezeReason || (data.freezeHistory && data.freezeHistory.length > 0 ? data.freezeHistory[0].reason : '');
        } else {
          statusText = 'ACTIVE';
        }

        const container = document.createElement('div');
        const statusSpan = document.createElement('span');
        statusSpan.className = `badge ${data?.deletedByCustomer ? 'bg-warning' : (data?.isFrozen ? 'bg-danger' : 'bg-success')}`;
        statusSpan.textContent = statusText;
        
        container.appendChild(statusSpan);
        
        if (reasonText) {
          const reasonSpan = document.createElement('div');
          reasonSpan.className = 'small text-muted mt-1';
          reasonSpan.textContent = reasonText;
          container.appendChild(reasonSpan);
        }
        
        return container;
      }
    },
   
    {
      headerName: 'Name',
      field: 'name',
      editable: false,
      filter: true,
      filterParams: {
        filterOptions: ['contains'],
        maxNumConditions: 1
      }
    },
    {
      headerName: 'Email Id',
      field: 'emailId',
      editable: false,
      filter: true,
      filterParams: {
        filterOptions: ['contains'],
        maxNumConditions: 1
      }
    },
    {
      headerName: 'Date of Birth',
      field: 'dob',
      editable: false,
      filter: false,
      valueFormatter: (params) => {
        if (!params.value) return '—';
        const date = new Date(params.value);
        if (isNaN(date.getTime())) return '—';
        const dobFormat = params.data?.citizenshipCountry?.dobFormat || params.data?.country?.dobFormat || 'DD-MM-YYYY';
        let d = String(date.getDate()).padStart(2, '0');
        let m = String(date.getMonth() + 1).padStart(2, '0');
        const y = date.getFullYear().toString();
        if (dobFormat === 'MM-DD-YYYY') return `${m}-${d}-${y}`;
        if (dobFormat === 'YYYY-MM-DD') return `${y}-${m}-${d}`;
        return `${d}-${m}-${y}`;
      },
    },
    {
      headerName: 'Device Id',
      field: 'deviceId',
      editable: false,
      filter: false,
    },
    {
      headerName: 'Country',
      field: 'country.displayName',
      editable: false,
      filter: true,
      filterParams: {
        filterOptions: ['contains'],
        maxNumConditions: 1
      }
    },
     {
      headerName: 'Citizenship',
      field: 'citizenshipCountry.displayName',
      editable: false,
      filter: true,
      filterParams: {
        filterOptions: ['contains'],
        maxNumConditions: 1
      }
    },
    {
      headerName: 'Mobile',
      field: 'mobile',
      editable: false,
      filter: true,
      filterParams: {
        filterOptions: ['contains'],
        maxNumConditions: 1
      },
      valueFormatter: (params) => {
        const mobile = params.value;
        if (!mobile) return '';
        
        const cleanMobile = mobile.replace(/[\s-]/g, '');
        const dialingCode = params.data?.country?.dialingCode;
        
        if (dialingCode) {
          const numberPart = cleanMobile.replace(dialingCode, '');
          if (numberPart && numberPart !== cleanMobile) {
            return `${dialingCode} ${numberPart}`;
          }
        }
        
        if (cleanMobile.startsWith('+91')) {
          return '+91 ' + cleanMobile.slice(3);
        } else {
          const countryCodeMatch = cleanMobile.match(/^(\+\d{1,3})(.*)$/);
          if (countryCodeMatch && countryCodeMatch[2]) {
            return `${countryCodeMatch[1]} ${countryCodeMatch[2]}`;
          }
        }
        
        return mobile;
      }
    },
    {
      headerName: 'Registered On',
      field: 'createdAt',
      editable: false,
      filter: false,
      valueFormatter: (params) =>
        this._dateService.getFormattedDateWithAMPM(params.value),
    },

  ];

  gridOptions: any = {
    paginationPageSize: 15,
    cacheBlockSize: 15,
    pagination: true,
    rowModelType: 'infinite',
    paginationPageSizeSelector: [15, 20, 50, 100],
    datasource: this.createDataSource(),
    rowSelection: 'multiple',
    context: {
      componentParent: this,
    },
  };

  onGridReady(params: any) {
    const vm = this;
    vm.gridApi = params.api;
    if (vm.gridApi) {
      vm.gridApi = params.api;
      vm.gridApi.sizeColumnsToFit();
    }
  }

  createDataSource() {
    const vm = this;
    const datasource = {
      getRows: (params: any) => {
        const startRow = params.startRow;
        const request = {
          _page: startRow / vm.gridOptions.paginationPageSize + 1,
          _limit: vm.gridOptions.paginationPageSize,
        };
        this.apiUrl = '/admin/customers' + '?_page=' + request._page + '&_limit=' + request._limit;
        const filterData = vm.gridApi.getFilterModel();
        Object.keys(filterData).forEach(k => {
          if (k && filterData[k]) {
            const raw = String(filterData[k].filter).replace(/[<>"';&]/g, '').slice(0, 200);
            if (raw) {
              vm.apiUrl = vm.apiUrl + '&' + k + '_like=' + encodeURIComponent(raw);
            }
          }
        });
        vm._api.getData(this.apiUrl).subscribe(async (res: any) => {
          if (res && !res.error) {
            // Use the data as received from the API without modifying isFrozen property
            params.successCallback(res.data, res.count);
          } else {
            params.failCallback();
          }
        });
      },
    };
    return datasource;
  }

  onView(data: any) {
    const customer = data.data;
    this.router.navigate(['/app/customers/details'], { queryParams: { id: customer._id } });
  }

  getCustomerDetails(id) {
    const vm = this;
    const apiUrl = '/admin/profile/' + id;
    vm._api.getData(apiUrl).subscribe((res: any) => {
      if (res && !res.error) {
        vm.customerData = res.data;

      }
    });
  }

  onClose() {
    this.modalRef.close();
  }

  dateFormat(value: any) {
    const vm = this;
    return vm._date.getDDMMYYYYfromEPOC(value);
  }

  getImage(id) {
    if (id && id.startsWith('http')) {
      id = new URL(id).pathname.split('/').pop();
    }
    const vm = this;
    vm._imageService.fetchAndViewDoc(id);
  }

  toggleAccountStatus(customer: any) {
    // Get account status first, then prepare the data for the modal
    this._api.getData(`/admin/account-freeze/${customer._id}/status`).subscribe({
      next: (response) => {
        if (!response.error) {
          // Prepare the data for the modal
          this.freezeModalData = {
            customerId: customer._id,
            customerName: customer.name,
            isFrozen: response.data.isFrozen || false
          };
        } else {
          // Default to customer data if status fetch fails
          this.freezeModalData = {
            customerId: customer._id,
            customerName: customer.name,
            isFrozen: customer.isFrozen || false
          };
        }

        // Reset form values
        this.freezeReason = '';
        this.otherReason = '';
        this.freezeNote = '';

        // Open the freeze/unfreeze modal
        this.freezeModalRef = this.modalService.open(this.freezeModal, { backdrop: 'static', size: 'md' });
      },
      error: (error) => {
        console.error('Error fetching account status:', error);
        // Default to customer data if status fetch fails
        this.freezeModalData = {
          customerId: customer._id,
          customerName: customer.name,
          isFrozen: customer.isFrozen || false
        };

        // Reset form values
        this.freezeReason = '';
        this.otherReason = '';
        this.freezeNote = '';

        // Open the freeze/unfreeze modal
        this.freezeModalRef = this.modalService.open(this.freezeModal, { backdrop: 'static', size: 'md' });
      }
    });
  }

  closeFreezeModal() {
    if (this.freezeModalRef) {
      this.freezeModalRef.close();
    }
  }

  confirmFreezeAction() {
    const finalReason = this.freezeReason === 'Other' ? this.otherReason : this.freezeReason;

    if (!finalReason) {
      return;
    }

    const payload = {
      customerId: this.freezeModalData.customerId,
      reason: finalReason,
      note: this.freezeNote || ''
    };

    if (this.freezeModalData.isFrozen) {
      // Unfreeze account
      this._api.postData('/admin/account-freeze/unfreeze', payload)
        .subscribe({
          next: (response) => {
            if (!response.error) {
              // Update the customer's freeze status in the selectedCustomer object
              this.selectedCustomer.isFrozen = false;

              this.closeFreezeModal();
              alert(`Account successfully unfrozen!`);
            } else {
              alert(`Error: ${response.message || 'Failed to unfreeze account'}`);
            }
          },
          error: (error) => {
            console.error('Error unfreezing account:', error);
            alert('Error unfreezing account: ' + (error.message || error));
          }
        });
    } else {
      // Freeze account
      this._api.postData('/admin/account-freeze/freeze', payload)
        .subscribe({
          next: (response) => {
            if (!response.error) {
              // Update the customer's freeze status in the selectedCustomer object
              this.selectedCustomer.isFrozen = true;

              this.closeFreezeModal();
              alert(`Account successfully frozen!`);
            } else {
              alert(`Error: ${response.message || 'Failed to freeze account'}`);
            }
          },
          error: (error) => {
            console.error('Error freezing account:', error);
            alert('Error freezing account: ' + (error.message || error));
          }
        });
    }
  }

}
